






















import { computed, defineNuxtComponent } from '~/utils/nuxt3-migration'
import CIcon from '~/components/shared/configurable/CIcon.vue'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { quickSearchCategories } from '~/constants/classified/quick-search'
import {
  QuickSearchCategories,
  QuickSearchCategory
} from '~/models/category/types'

export default defineNuxtComponent({
  components: {
    CLink,
    CIcon
  },
  props: {
    selectedRootCategoryName: {
      type: String,
      default: null
    },
    selectedCategories: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const categories = computed(() => {
      if (!props.selectedRootCategoryName) return []
      return (
        (quickSearchCategories as QuickSearchCategories)[
          props.selectedRootCategoryName
        ]?.children || []
      )
    })

    function getCategoryIcon(category: QuickSearchCategory) {
      return categoriesIconsMappings[category.id as number]
    }

    function isActive(category: QuickSearchCategory) {
      return props.selectedCategories.includes(category.id)
    }

    return {
      categories,
      getCategoryIcon,
      isActive
    }
  }
})
